import { render } from "./SidebarNavItem.vue?vue&type=template&id=797938c2&scoped=true&lang=pug"
import script from "./SidebarNavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNavItem.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNavItem.vue?vue&type=style&index=0&id=797938c2&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797938c2"]])

export default __exports__